'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadl';
var iconName = 'police-box';
var width = 384;
var height = 512;
var aliases = [];
var unicode = 'e021';
var svgPathData = ['M64 96l0 384 256 0 0-384c-17.7 0-32-14.3-32-32L96 64c0 17.7-14.3 32-32 32zm32 72c0-22.1 17.9-40 40-40l112 0c22.1 0 40 17.9 40 40l0 32c0 22.1-17.9 40-40 40l-40 0 0 40c0 22.1-17.9 40-40 40l-32 0c-22.1 0-40-17.9-40-40l0-112z', 'M208 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 16-80 0c-17.7 0-32 14.3-32 32-17.7 0-32 14.3-32 32l0 384-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l352 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-384c0-17.7-14.3-32-32-32 0-17.7-14.3-32-32-32l-80 0 0-16zm80 48c0 17.7 14.3 32 32 32l0 384-256 0 0-384c17.7 0 32-14.3 32-32l192 0zM136 128c-22.1 0-40 17.9-40 40l0 112c0 22.1 17.9 40 40 40l32 0c22.1 0 40-17.9 40-40l0-40 40 0c22.1 0 40-17.9 40-40l0-32c0-22.1-17.9-40-40-40l-112 0zm40 32l0 48-48 0 0-40c0-4.4 3.6-8 8-8l40 0zm0 80l0 40c0 4.4-3.6 8-8 8l-32 0c-4.4 0-8-3.6-8-8l0-40 48 0zm32-80l40 0c4.4 0 8 3.6 8 8l0 32c0 4.4-3.6 8-8 8l-40 0 0-48z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faPoliceBox = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;